export const library = {
  messagesHaveFeed(messages, feed) {
    // console.log(feed);
    if (feed == undefined || feed.fed_id == undefined)
      return false;
    if (messages.length == 0)
      return false;
    for (let i = 0; i < messages.length; i++) {
      if (messages[i].fed_id == undefined) {
        // console.log('Doesn"t have it it');
        return false;
      }
      if (messages[i].fed_id == feed.fed_id) {
        // console.log('Have it');
        return true;
      }

    }
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/library.js